import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import BackgroundBox from '../../../components/custom_components/BackgroundBox'
import PerButton from '../../../components/custom_components/Button'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import PerIcon from '../../../components/custom_components/Icon'

export type ShowMoreButtonProps = {
  visible: boolean
  loadingMore: boolean
  onLoadMore: () => void
}

export const ShowMoreButton: FC<ShowMoreButtonProps> = ({ visible, loadingMore, onLoadMore }) => {
  const { t } = useTranslation()
  const label = t('global.showMore')

  if (!visible) {
    return null
  }

  return (
    <BackgroundBox mt="xxxs" r height="tabbar" noPadding>
      <PerFlexRow align="middle" justify="center" className="fullHeight">
        <PerButton
          color="white"
          text={label}
          onClick={() => {
            if (!loadingMore) onLoadMore()
          }}
        />
        {loadingMore && <PerIcon name="loading_fill" color="primary" size={16} spin />}
      </PerFlexRow>
    </BackgroundBox>
  )
}
